var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useEffect, useState } from 'react';
import { Icon } from "../UI";
import { store } from "../store";
import { SidePanel } from "../Layout";
import { Translate } from "../I18N";



import SourceDocument from "../Viewer/components/SourceDocument";
import { DocumentForm } from "../Viewer/containers/DocumentForm";
import { loadFetchedInReduxForm } from "../Metadata/actions/actions";
import { fetchEntity, fetchFile, scrollToPage } from "./actions/actions";








const PDFSidePanel = ({
  open,
  entitySuggestion,
  closeSidePanel,
  handleSave
}) => {
  const [entity, setEntity] = useState({});
  const [file, setFile] = useState({});
  const templates = store === null || store === void 0 ? void 0 : store.getState().templates;

  useEffect(() => {
    fetchEntity(entitySuggestion.entityId, entitySuggestion.language).
    then((response) => {
      setEntity(response[0]);
      loadFetchedInReduxForm(
      'documentViewer.sidepanel.metadata',
      response[0],
      templates === null || templates === void 0 ? void 0 : templates.toJS()).
      forEach((action) => store === null || store === void 0 ? void 0 : store.dispatch(action));
    }).
    catch((e) => e);
  }, [entitySuggestion]);

  useEffect(() => {
    if (entitySuggestion.fileId) {
      fetchFile(entitySuggestion.fileId).
      then((response) => {
        setFile(response.json[0]);
      }).
      catch((e) => e);
    }
  }, [entitySuggestion]);

  return open ? /*#__PURE__*/
  _jsx(SidePanel, { className: "wide", open: open }, void 0, /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx("div", { className: "sidepanel-header buttons-align-right" }, void 0, /*#__PURE__*/
  _jsx("button", {
    type: "button",
    className: "closeSidepanel close-modal",
    onClick: closeSidePanel,
    "aria-label": "Close side panel" }, void 0, /*#__PURE__*/

  _jsx(Icon, { icon: "times" })), /*#__PURE__*/

  _jsx("div", { className: "button-list" }, void 0, /*#__PURE__*/
  _jsx("button", { type: "button", className: "btn btn-default", onClick: closeSidePanel }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Cancel")), /*#__PURE__*/

  _jsx("button", { type: "submit", className: "btn btn-success", form: "metadataForm" }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Save")))),



  entity.sharedId && file.filename && /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx(DocumentForm, {
    sharedId: entity.sharedId,
    showSubset: [entitySuggestion.propertyName],
    storeKey: "documentViewer",
    fileID: entitySuggestion.fileId,
    onEntitySave: handleSave }), /*#__PURE__*/

  _jsx("div", { className: "document-viewer" }, void 0, /*#__PURE__*/
  _jsx(SourceDocument, {
    file: file,
    onPageLoaded: async () => {
      await scrollToPage(entitySuggestion.page || 1);
    } }))))) : /*#__PURE__*/







  // eslint-disable-next-line react/jsx-no-useless-fragment
  React.createElement(React.Fragment, null);

};

export { PDFSidePanel };